module.exports = __webpack_public_path__ + "static/media/gamification_3_zh_HK.6b20df96.png";